import { defineRouting } from "next-intl/routing";

// =============================================================================

export const routing = defineRouting({
  locales: ["en", "fr"],
  defaultLocale: "en",
  localePrefix: "always",
  // hreflang links come from the page metadata (createPageMetadata): no
  // second, diverging set in a Link header
  alternateLinks: false,
});

export type AppLocale = (typeof routing.locales)[number];

// =============================================================================
